"use client"

import {useEffect} from "react";
import {useTranslations} from "next-intl";
import {setSupportCodeToastTexts} from "@/app/components/common/app-toast/supportCodeToastTexts";

/**
 * Hands the current locale's wording to showSupportCodeToast (AC-940), which is
 * called outside React and rendered outside NextIntlClientProvider. Headless;
 * mounted once in the locale layout.
 */
export default function SupportCodeToastInitializer() {
    const t = useTranslations('Errors');

    useEffect(() => {
        setSupportCodeToastTexts({
            title: t('somethingWentWrong'),
            description: (code) => t('supportCode', {code}),
        });
    }, [t]);

    return null;
}
